import { cpfValidator } from "./cpfValidator";
import { passportValidator } from "./passportValidator";

export const dynamicValidation = (value: any) => {
  if (cpfValidator(value)) return true;
  if (passportValidator(value)) return true;
  return false;
};
